const baseLangMatch = window.location.href.match(
  /^https?\:\/\/(?:www\.)?entrade\.([a-z]+)/
);
const baseLangMap = { se: "sv", fi: "fi" };
const baseLang = baseLangMap[baseLangMatch ? baseLangMatch[1] : "se"];
let currentLang = "sv";
if ($("body.lang-en").length === 1) currentLang = "en";
if ($("body.lang-fi").length === 1) currentLang = "fi";

let langs = ["sv", "en"];
if (baseLang === "fi") langs = ["fi", "sv", "en"];

const texter = {
  0: {
    sv: "Du har värmepumpen<br>Vi har tillbehören",
    fi: "Sinulla lämpöpumppu? Meillä on siihen asennustarvikkeet!",
    en: "You have the heat pump<br>We have the accessories",
  },
  1: {
    sv: "Med över 900 artiklar på lager kan vi alltid leverera när du behöver det.",
    fi: "Yli 900 nimikettä varastossamme valmiina toimitettavaksi sinulle",
    en: "Over 900 products on stock.<br>We can always deliver when you need it.",
  },
  2: {
    sv: "<p>Högsta kvalitet Till bästa pris</p><p>Under eget varumärke</p>",
    fi: "<p>QsanTec tuotemerkkimme</p><p>takaa korkean laadun parhaalla hinnalla</p>",
    en: "<p>Highest quality to the best price</p><p>Our own brand</p>",
  },
  3: {
    sv: "Hem",
    fi: "Koti",
    en: "Home",
  },
  4: {
    sv: "Grundpris",
    fi: "Ohjehinta",
    en: "Base price",
  },
  5: {
    sv: "Alla priser är exkl. moms",
    fi: "Hinnat alv 0 %",
    en: "All prices are excl. VAT",
  },
  6: {
    sv: "Populära produkter",
    fi: "Suosituimmat tuotteet",
    en: "Popular products",
  },
  7: {
    sv: "Produktkod",
    fi: "Tuotekoodi",
    en: "Product code",
  },
  8: {
    sv: "Visa per sida:",
    fi: "Näytä tuotteita sivulla:",
    en: "Items per page:",
  },
  9: {
    sv: "produkter",
    fi: "tuotetta",
    en: "items",
  },
  10: {
    sv: "Sortering:",
    fi: "Lajittelu:",
    en: "Sort by:",
  },
  11: {
    sv: "Sida",
    fi: "Sivu",
    en: "Page",
  },
  12: {
    sv: "Kampanj",
    fi: "Kampanja",
    en: "Campaign",
  },
  13: {
    sv: "Rekommenderat",
    fi: "Suositeltava",
    en: "Recommended",
  },
  14: {
    sv: "Produkten finns inte i lager, vill du beställa den ändå?",
    fi: "Tuotetta ei ole varastossa, haluatko silti tilata sen?",
    en: "The product is not in stock, do you want to order it anyway?",
  },
  15: {
    sv: "Avbryt",
    fi: "Ei peruuta",
    en: "Cancel",
  },
  16: {
    sv: "OK",
    fi: "Joo",
    en: "OK",
  },
};

const t = (key) => texter[key][currentLang];

let katalog = $(`
<div class="catalog-box">
  <a href="https://jbflipbooks.aflip.in/entrade18.html" class="fw-button fw-button-primary btn-action" target="_blank">Läs katalogen</a>
	<img src="/images/user/catalog-image1.png">
</div>
`);

if (currentLang === "fi")
  katalog = $(`
<div class="catalog-box">
	<a href="/images/user/Qsantec_Esite_8-s_web.pdf" class="fw-button fw-button-primary btn-action">PDF katalogimme tästä!</a>
	<img src="/images/user/catalog-image1.png">
</div>
`);

const logo = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.29 21.17">
  <path fill="currentColor" d="M1.07 19.56V1.36h14.82v4.47H6v2.41h7.95v4.2H5.99v2.65h9.9v4.47ZM22.24 9.55v10h-5.13V1.38h4.44l8.3 10.03V1.37h5.13v18.19H30.5zm24.3-3.05v13.06H41.4V6.5h-5.2V1.37h15.5V6.5zm30.87-5.13h6.08l6.74 18.19h-5.2l-1.09-3.08h-7.09l-1.07 3.08H70.6Zm.73 11.34h4.57l-2.27-6.29zM91.52 1.37H100c5.38.02 9.39 3.2 9.39 9.12 0 5.86-4.01 9.07-9.4 9.07h-8.47zm5.13 4.44v9.3h3.1c2.58 0 4.32-1.68 4.32-4.62 0-3-1.74-4.68-4.31-4.68zm13.95 13.75V1.36h14.83v4.47h-9.9v2.41h7.94v4.2h-7.94v2.65h9.9v4.47Zm17.3-17.82v1.58h-.37V1.74h-.66v-.37h1.67v.37zm2.94.21-.67.83h-.08l-.68-.83v1.37h-.37V1.37h.32l.77.92.77-.92h.32v1.95h-.38zM70.83 15.08a6.4 6.4 0 0 1-1.85.31c-1.5 0-2.97-1.28-4.52-2.62 2.6-.66 4.44-2.64 4.44-5.37 0-4.06-3.3-6.03-6.76-6.03h-9.22v18.16h5.13v-6.66l.24.14c2.48 1.63 5.58 6.8 9.86 6.8.31 0 .62-.03.92-.07zm-9.2-5.57h-3.58v-3.7h3.58c1.25 0 1.98.82 1.98 1.86 0 1.02-.73 1.84-1.98 1.84" />
</svg>
`;

// wrappa headern
$("header").wrapInner('<div class="header-wrapper"></div>');

//lägg till språkflaggor
let flaggHtml = '<div id="Flagga">';
for (let lang of langs) {
  const langLink = "/" + lang + "/ChangeLanguage";
  flaggHtml += `<a href="${langLink}"><img ${
    currentLang === lang ? 'class="active"' : ""
  } src="/Images/user/${lang}.svg"></a>`;
}
flaggHtml += `</div>`;
$("header .header-wrapper").append(flaggHtml);

// byter ut endast produktmeny mot hela menyn
const navTree = $("#NavTree-Horisontell .fw-drawer").clone();
$("#NavTree-Horisontell .fw-drawer").html($("#MainMenu .fw-drawerMenu").html());
$("#NavTree-Horisontell .fw-drawer").attr("class", "fw-drawerMenu menu");
const drawer = $("#NavTree-Horisontell > .fw-drawerMenu");

//tar bort tomma dropdowns (Mina sidor om man är utloggad)
drawer.find(".level1").each(function () {
  if ($(this).find("ul").length > 0 && $(this).find("ul li").length === 0)
    $(this).remove();
});

//level2 -> level1, level3 -> level1 för att få dropdown på alla
drawer.find(".level2").removeClass("level2").addClass("level1");
drawer.find(".level3").removeClass("level3").addClass("level1");
$(document).unbind("mouseup");

//wrappa alla ul
drawer.find(".level1 > ul").wrapInner('<div class="ul-wrapper"></div>');

//dölj vid klick utanför
$(document).click((e) => {
  if ($("#CloseTree:visible").length === 0) {
    if ($(e.target).parent().find(".fw-drawerContent").length === 0) {
      drawer
        .find(".fw-drawerContent")
        .removeClass("fw-drawerContentShow")
        .addClass("fw-drawerContentHide");
    }
  }
});

//sidomeny för produkt- och kategorisidor
if (
  $("body.page-Prodview, body.page-ProdGroup").length === 1 ||
  ($("body.page-Prodlist").length === 1 &&
    $(".mainContent").text().trim().length > 0)
) {
  $("#Main").wrap('<div id="SidomenyMainWrapper"></div>');
  $("#SidomenyMainWrapper").prepend(navTree);
  $("#SidomenyMainWrapper > .fw-drawer").wrap('<div id="Sidomeny"></div>');

  $("#SidomenyMainWrapper a[href$=Varmepumpstillbehor]").html(
    "Värmepumps&shy;tillbehör"
  );
}

//all info i infowrapper på produktsidan
$("body.page-Product #InfoWrapper").prepend($("#ProductInfo"));

//fix för köpknapp
setInterval(() => {
  if ($("[id=ProductInfo]").length > 1) {
    $("body.page-Product #InfoWrapper [id=ProductInfo]").remove();
    $("body.page-Product #InfoWrapper").prepend($("[id=ProductInfo]"));
  }
}, 100);

//ta bort tomma cols i Accessories-tabellen
let filledCols = new Set([]);
$("#Accessories .table .row").each(function () {
  $(this)
    .children(".cell")
    .each(function (i) {
      if ($(this).html() !== null && $(this).html().trim().length > 0)
        filledCols.add(i);
    });
  $(this)
    .children(".cell")
    .each(function (i) {
      if (!filledCols.has(i)) $(this).hide();
    });
});
$("#Accessories .table .header")
  .children(".cell")
  .each(function (i) {
    if (!filledCols.has(i)) $(this).hide();
  });

//ikoner
const ikoner = [
  "ror",
  "kanaler",
  "konsoler",
  "tillbehor",
  "verktyg",
  "el-tillbehor",
  "kondensvatten-pumpar",
  "tillbehor-service",
];

//outlet om det finns i navTree
if (
  navTree.find(".level1:not(.title) > a:contains(Outlet)").length === 1
) {
  ikoner.push("outlet");
}

//kampanj om det finns i navTree
if (
  navTree.find(".level1:not(.title) > a:contains(" + t(12) + ")").length === 1
) {
  ikoner.push("kampanj");
}

const kategorier = [];
navTree
  .find(".level1.title > div > a, .level1:not(.title) > a")
  .each((i, v) => {
    if (i < ikoner.length)
      kategorier.push([$(v).text(), $(v).attr("href"), ikoner[i]]);
  });

$("header").append($('<div id="Ikoner"><div id="IkonerWrapper"></div></div>'));
$("#IkonerWrapper").html(
  kategorier
    .map(
      (v) =>
        '<a href="' +
        v[1] +
        '" class="ikon-' +
        v[2] +
        '"><img src="/images/user/' +
        v[2] +
        '.png"><div>' +
        v[0].replace("Värmepumpstillbehör", "Värmepumps-tillbehör") +
        "</div></a>"
    )
    .join("\n")
);

if ($("#StartView").length === 1) {
  $("#StartView").append(
    `
		<div class="start-columns-e2">
			<div class="start-column-e2 start-column-left-e2"></div>
			<div class="start-column-e2 start-column-right-e2">
				<h2>
          ${t(6)}
        </h2>
			</div>
		</div>
	`
  );
  $(".start-column-left-e2").html(
    $("#StartView #ProdListHeader .list_info").html()
  );
  $(".start-column-right-e2").append($("#StartView .mainContent"));

  //katalog
  $(".start-column-right-e2").append(katalog);

  const karusell = $(`
  <div class="siema">
    <div style="background-image: url('/images/user/bildspel1.jpg');">
      <p class="tagline">` + t(0) + `</p>
    </div>
    <div style="background-image: url('/images/user/bildspel2.jpg');">
      <div class="dark-bg"></div>
      <p>` + t(1) + `</p>
    </div>
    <div>
      <h2>QsanTec</h2>
      ` + t(2) + `
    </div>
  </div>
  `)

  //karusell
  $('#StartView').prepend(karusell)
  $('#EndScripts').append('<script src="/scripts/siema.min.js"></script>')

  $('#EndScripts').append(`
    <script>
      let siemaCountdown = 5
      let focused = true
      $(window).focus(()=>focused = true)
      $(window).blur(()=>focused = false)
      const siemanext = ()=>{
        if(focused) {
          if(siemaCountdown > 0) siemaCountdown -= 1
          else siema.next()
        }
      }
      const siema = new Siema({
        loop: true,
        duration: 1500,
        onInit: ()=>{
          $('.siema').css('visibility', 'visible')
        },
        onChange: ()=>{
          siemaCountdown = 5
        }
      })
      setInterval(siemanext, 1000)
    </script>
  `)

  //kampanj-boxar
  const kampanjRubrik = $("#Main h2")
    .filter(function () {
      return $(this).text().toLowerCase().includes(t(12).toLowerCase());
    })
    .slice(0, 1);
  if (kampanjRubrik.length === 1) {
    $('<div class="kampanj-boxar-e2"></div>').insertAfter(kampanjRubrik);
    let tagnaBoxar = 0;
    $($(".start-column-right-e2 .mainContent .row").get().reverse()).each(
      function () {
        if (tagnaBoxar >= 5) return;
        const kampanjBox = $('<div class="kampanj-box-e2"></div>');
        kampanjBox.append($(this).find(".D10088"));
        kampanjBox.find(".D10088").append($(this).find(".D22302"));
        $(".kampanj-boxar-e2").append(kampanjBox);
        //$(this).hide()
        tagnaBoxar++;
      }
    );
  }
}

//gör titel till "Entrade" on den saknas
if ($("title").text().trim().length === 0) $("title").text("Entrade");

//ta rubrik från titel om den saknas
if ($("#Main h1").eq(0).text().trim().length === 0)
  $("#Main h1").eq(0).text($("title").text());
if ($("#Main h1").length === 0)
  $("#Main").prepend($("<h1>" + $("title").text() + "</h1>"));

//ta bort rubrik om den är "Om Entrade"
if ($("#Main h1").eq(0).text().trim() === "Om Entrade")
  $("#Main h1").eq(0).text("");

//flytta till productView om det är flex på g
if ($(".cross-items .main").length > 0)
  $("#Main .prodlistView").prepend($("#Main h1"));

//dölj tomma element
$(
  ".cross, .groupview-text p, h1, .comboBoxData .row, .product-description-e2 p"
).each(function () {
  if ($(this).text().trim().length === 0) $(this).hide();
});

//fulfix för att exekvera efter alphaScriptBundle
setTimeout(() => {
  $("img.currentCountry").attr("src", "/Images/user/" + currentLang + ".svg");

  //positionera och dölj syskon vid klick
  drawer.find("li.title").click((e) => {
    $(e.currentTarget)
      .siblings("li.title")
      .find(".fw-drawerContent")
      .removeClass("fw-drawerContentShow")
      .addClass("fw-drawerContentHide");
    if (!$(e.currentTarget).parent().hasClass("menu")) {
      //desktop eller mobil
      if ($(e.currentTarget).children("ul").css("position") === "absolute") {
        $(e.currentTarget)
          .children("ul")
          .css("left", $(e.currentTarget).width() + "px");
      } else {
        $(e.currentTarget).children("ul").css("left", "0");
      }
    }
  });
}, 100);

//Hem -> Produkter i breadcrumbs
$(".breadcrumbs .breadlink").each((i, v) => {
  if ($(v).text() === "Hem") $(v).text("Produkter");
});

//Logo i header och footer
$("#Logo a").html(logo);
$("footer .companyName").html(logo);

//dela upp footer
$("footer .footerInfo").append($('<div class="footerCol"></div>'));
$("footer .footerCol").append($("footer .companyAddress"));
$("footer .footerCol").append($("footer .companyVAT"));
$("footer .footerInfo").prepend($('<div class="footerCol"></div>'));
$("footer .footerCol:first").append($("footer .companyName"));
$("footer .footerCol:first").append($("footer .companyEmail"));
$("footer .footerCol:first").append($("footer .companyPhoneNo"));

//formatera titel
$(".product-name").each(function () {
  $(this).text(
    $(this)
      .text()
      .replace(/(\S)\+(\S)/g, "$1 + $2")
  );
});

//hämta beskrivning och egenskaper
const productDescription = $("#TabContent #Description .text").html();
const productProperties = [
  [t(7), $("#ProductInfo #ProductCode .value").text()],
];
$("#TabContent #Specifications .table .row").each(function () {
  productProperties.push([
    $(this).find(".cell:first").text().trim(),
    $(this).find(".cell:last").text(),
  ]);
});

//bygg kolumner till produkt
$("#ProductWrapper #Details").wrap('<div class="product-details-e2"></div>');
$(".product-details-e2").prepend('<div class="product-properties-e2"></div>');

//flytta till första kolumn
$(".product-properties-e2").append($("#ProductWrapper #Availability"));
$(".product-properties-e2").append(
  '<div class="product-properties-list-e2">' +
    productProperties
      .map((v) => "<div><span>" + v[0] + ":</span> " + v[1] + "</div>")
      .join("\n") +
    "</div>"
);

$('<div class="product-description-e2"></div>').appendTo(
  $(".product-details-e2")
);
$(".product-description-e2").html(productDescription);
$('.product-description-e2 p:contains("OBS!")').insertAfter(
  $("#ProductButtonGroup")
);

$(".product-details-e2 .details").appendTo(".product-properties-e2");

$("#hlProdAsk, #lbtnAddFavorite").wrap($('<div class="hl-holder-e2"></div>'));
$(".product-properties-e2").append($(".hl-holder-e2"));

//plocka ut grundpris
const grundpris = $("#ProductPrices .price:last .value")
  .text()
  .replace(/[^0-9]/g, "")
  .replace(/([0-9]{2})$/, ":$1");

//till andra kolumn
if (grundpris) {
  $(`<div>${t(4)}: ${grundpris}</div><div>${t(5)}</div>`).insertAfter(
    $(".product-details-e2 .price-wrapper")
  );
}

//ta bort alla i
$(".fw-icon-info").parent().hide();

//rubrik högst upp
$(".prodlistView").prepend($(".prodlistView h1:first"));

//NY-bild till bild
$(".selected-image-wrapper #image_link").append($("#GroupImage"));

//spara produkt-html
const produktHtml = $("#ProductWrapper").html();

//intervall pga omrendering vid sortering
const upprepas = () => {
  //404 på produktbilder
  const img404 =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAHCBAMAAACONtR2AAAAFVBMVEXy7fTXyN7f0uTj2efXyd7n3evg1ebTVZ0cAAABvUlEQVR42uzbUQ3CQBQF0QUFQOCfVAEJFhCABPyrIE8Au2lJ00s4x8EImAYAAAAAAAAAAAAAAAAAAAAAAAAAAABAqv20vmvb0u64vkObQaFChUWhQoV9ChUqLAoVKuxTqFBhUahQYZ9ChQqLQoUK+xQqVFgUKlTYp1ChwqJQocI+hQoVFoUKFfYpVKiwKFSosE+hwvmFp/vXbm1D48JL+3EKFeZTqDCfQoX5FCrMp1BhPoUK8ylUmE+hwnwKFeZTqDCfwuP5scSrxajCFSj8TKFChQoVKhxTqFChQoUKxxQqVKhQocIxhQoVKlSocEyhQoUKFSocU6hQoUKFCscUKlSoUKHCMYUKFf5j4Wla4tlieGYU5lOoMJ9ChfkUKsynUGE+hQrzvdu7YxMAoSgIgmIlYv9FyqUGLxHh9M90sBWsQoX9FCrsp1BhP4UK+ylU2E/hAoX/P8s9Vn8HVKhQ4Z1ChQpDoUKFM4UKFYZChQpnChUqDIUKFc4UKlQYChUqnClUqDAUKlQ4U6hQYShUqHCmUKHCUKhQ4UyhQoWh8GOF+/m+YwMAAAAAAAAAAAAAAAAAAAAAAAAAAACg1AU/skbP4YnSfwAAAABJRU5ErkJggg==";
  $("#updProduct img, .productContainer img").on(
    "error",
    (e) => (e.target.src = img404)
  );

  //paginering
  const hitsNo = $("#FilterHits .hitsNo").clone();
  if (hitsNo.text().length > 0) {
    if ($(".prodlistView").length > 0 && $("#ProdListHeader").length === 0) {
      $(".prodlistView").prepend(
        '<div id="ProdListHeader" class="prodlist-header onset title-yes info-no image-no"><div class="list_info"></div></div>'
      );
    }

    if ($(".prodlistView").length > 0 && $("#PagerBottom").length === 0) {
      $(".prodlistView").append('<div id="PagerBottom"></div>');
    }

    let sidor = Math.ceil(
      parseInt($(".hitsNo").text(), 10) /
        parseInt($(".currentRowsText").text(), 10)
    );
    if (!isFinite(sidor)) sidor = 1;

    const currentUrl = new URL(window.location.href);
    const currentPage = parseInt(currentUrl.searchParams.get("page") ?? 1, 10);
    let paginering = "";

    for (let i = 1; i <= sidor; i++) {
      if (i <= 3 || Math.abs(i - currentPage) < 3 || i > sidor - 3) {
        const url = new URL(currentUrl);
        url.searchParams.set("page", i);
        paginering += `<a ${
          i === currentPage ? 'class="active"' : ""
        } href="${url}">${i}</a>`;
      } else if (!paginering.includes("...")) {
        paginering += '<div class="ppp-e2">...</div>';
      }
    }

    // paginering vid sökning
    if (
      $("#FirstPager a").length > 0 &&
      $("#FirstPager a").attr("href").startsWith("javascript:")
    ) {
      const pagerSida = $("#FirstPager .pagerText").text();

      paginering = "";
      $("#FirstPager a").each(function () {
        const newA = $("<a></a>");
        newA.attr("href", $(this).attr("href"));
        newA.html($(this).html());
        if ($(this).attr("title") === "Nästa") {
          paginering += pagerSida;
        }
        paginering += newA[0].outerHTML;
      });
      if (!paginering.includes(pagerSida)) {
        paginering += pagerSida;
      }
    } else {
      paginering = "<div>" + t(11) + ": </div>" + paginering;
    }

    paginering = '<div class="paginering-e2">' + paginering + "</div>";

    const pagineringEl = $(
      '<div class="list-status-e2">' + paginering + "</div>"
    );

    if ($(".list-status-e2").length > 0) {
      if ($(".list-status-e2").text() !== pagineringEl.text()) {
        $(".list-status-e2").html(pagineringEl.html());
      }
    } else {
      $("#FilterWrapper").append(pagineringEl.prop("outerHTML"));
    }

    $('#FilterHits').html('')
  }

  //hits till under rubrik
  if ($(".list-status-e2 .hits-e2").length === 0) {
    $(".list-status-e2").prepend(hitsNo);
    $(".list-status-e2 .hitsNo").wrap('<div class="hits-e2"></div>');
    $(".hits-e2").append(" " + t(9));
  }

  //paginering på botten alltid
  if ($("#PagerBottom .paginering-e2").length === 0)
    $("#PagerBottom").html(
      $(".list-status-e2 .paginering-e2").prop("outerHTML")
    );

  //Kampanj-header
  if (
    $("#Main h1").eq(0).text().trim() === t(12) &&
    $("#Main h1").eq(0).css("display") !== "none"
  ) {
    $("#Main h1").eq(0).hide();
    $("#ProdListHeader .list_info").prepend(
      `<img style="margin-top: 2.5rem" src="/Images/user/${t(
        12
      ).toLowerCase()}rubrik.png" alt="${t(12)}">`
    );
    $("#ProdListHeader .list_info").addClass("kampanj");
  }

  //NY-bild i prodlist list
  $(".prodlist.list-view .row .cell:not(.ArtImg) .image").each(function () {
    $(this)
      .css("position", "absolute")
      .css("top", 0)
      .css("left", 0)
      .css("min-width", "40px")
      .css("max-width", "40px");
    $(this).closest(".cell").hide();
    $(this)
      .closest(".row")
      .find(".cell.ArtImg")
      .css("position", "relative")
      .prepend($(this));
  });

  //produktkod i prodlist list
  $(".prodlist.list-view .row > .cell.D22302").each(function () {
    $(this).wrap('<div class="product-name-code-e2"></div>');
    $(this)
      .parent()
      .prepend(
        $(
          `<div class="product-code-e2">${$(this)
            .parent()
            .siblings(".cell.D22301")
            .text()}</div>`
        )
      );
  });

  //fråga om köp vid OutOfStock
  const confirmPopup = (e, text) => {
    e.preventDefault();
    $(`
			<div class="confirm-popup-e2">
				<div class="confirm-popup-e2__content">
					<div class="confirm-popup-e2__text">${text}</div>
					<div class="confirm-popup-e2__buttons">
						<button class="confirm-popup-e2__button confirm-popup-e2__button--cancel">
              ${t(15)}
            </button>
						<button class="confirm-popup-e2__button confirm-popup-e2__button--confirm">
              ${t(16)}
            </button>
					</div>
				</div>
			</div>
		`).appendTo("body");
    $(".confirm-popup-e2__button--cancel").on("click", () =>
      $(".confirm-popup-e2").remove()
    );
    $(".confirm-popup-e2__button--confirm").on("click", () => {
      $(".confirm-popup-e2").remove();
      window.location.href = e.target.href;
    });
  };

  $("a").click(function (e) {
    if (
      $(this).hasClass("btn-buy") &&
      $(this)
        .closest(".row, .product-details-e2")
        .find(
          ".fw-icon-stock.fw-stock-onorder, .fw-icon-stock.fw-stock-outofstock"
        ).length > 0
    ) {
      if ($(".confirm-popup-e2").length === 0) confirmPopup(e, t(14));
      else e.preventDefault();
    }
  });

  //dölj vanlig prislapp vid sale, även på boxar
  $(".price.sale").siblings(".price").hide();

  //dölj alla andra prislappar
  $("#ProductPrices .price:not(:first)").hide();

  //formatera pris
  $(".D12813").each(function () {
    if ($(this).find(".wrapper-e2").length === 0)
      $(this).wrapInner('<div class="wrapper-e2"></div>');
  });
  $(".price > .value, .D12813 > .wrapper-e2").each(function () {
    const price = $(this)
      .text()
      .replace(/[^0-9. ]/g, "")
      .replace(/^ *\./, "");
    if (price.includes(".")) {
      let [priceInt, priceDec] = price.split(".");
      priceInt = priceInt.replace(" ", "&#8239;") + "&#8239;";
      priceDec = '<span class="decimals">' + priceDec + "</span>";
      //SEK om engelska
      let priceSuffix = "";
      if (currentLang === "en") {
        priceSuffix = '<span class="currency">SEK</span>';
      }
      $(this).html(priceInt + priceDec + priceSuffix);
    }
  });

  //lägg till plus och minus
  $(".quantity > .numeric > .textBox").each(function () {
    if ($(this).siblings(".modifier").length === 0) {
      const parent = $(this).closest(".row, .product-details-e2, .inner");
      let amount = parent.find(".D1067, .D1067_value").text(); //förpackningsstorlek
      if (amount.length === 0)
        amount = parent.find(".D18236, .D18236_value").text(); //föreslaget antal
      if (amount.length === 0) amount = "1";

      $(
        `<div class="modifier minus" data-amount="` + amount + `">-</div>`
      ).insertBefore(this);
      $(
        `<div class="modifier plus" data-amount="` + amount + `">+</div>`
      ).insertAfter(this);
    }

    $(this)
      .siblings(".modifier")
      .off("click")
      .click(function () {
        const amount = parseInt($(this).attr("data-amount"), 10);
        const sign = $(this).text() === "-" ? -1 : 1;
        const textBox = $(this).parent().find(".textBox");
        textBox.val(Math.max(0, parseInt(textBox.val(), 10) + amount * sign));
      });
  });

  //bild och text har samma länk
  $(".image-inner > a").each(function () {
    if ($(this).find(".product-name-e2").length === 0) {
      $(this).append(
        `<div class="product-code-e2">
          ${$(this)
            .closest(".inner")
            .find(".description-wrapper .product-code")
            .text()}
        </div>
        <div class="product-name-e2">
          ${$(this)
            .closest(".inner")
            .find(".description-wrapper .product-name")
            .text()}
        </div>`
      );
    }
  });

  //cross-item grid-bredd
  $(".cross-item").removeClass("fw-");

  //bild och text har samma länk cross-items
  $(".cross-item .info-wrapper > .description-wrapper").each(function () {
    $(this).prepend($(this).children(".cross-code"));
    $(this).prepend($(this).parent().siblings(".image-wrapper"));
    const title = $(this).find(".cross-name").text();
    $(this).find(".cross-name > a").text("");
    $(this).wrap($(this).find(".cross-name > a"));
    $(this).find(".cross-name").text(title);
  });

  //Rubrik för mobil
  if ($(".cross > h2").length === 0)
    $(".cross").prepend('<h2 class="title">' + t(13) + "</h2>");

  //större bild för liggande bilder
  $(".image-inner img").each(function () {
    if (!$(this).parent().hasClass("img-holder-e2"))
      $(this).wrap('<div class="img-holder-e2"></div>');
  });

  //sökfilter
  if ($("#SortContentTitle").text() !== t(10))
    $("#SortContentTitle").text(t(10));
  if ($("#ShowRowsText").text() !== t(8)) $("#ShowRowsText").text(t(8));

  if (
    produktHtml &&
    produktHtml.length > 0 &&
    $("#ProductWrapper .product-details-e2").length === 0
  )
    $("#ProductWrapper").html(produktHtml);

  //css laddas ur vid tömning av kundvagn
  if ($('link[href^="/css/user.css"]').length === 0) {
    $("head").append(
      '<link rel="stylesheet" href="/css/user.css" type="text/css" />'
    );
  }
};

upprepas();
setInterval(upprepas, 200);

$("#Page").css("visibility", "visible");
$("#Laddar").hide();
